import { NomadDB } from '~/db/NomadDB.js';
import type { ExerciseSchema } from '@/types/schema';

export const getExercisesService = (db: NomadDB) => {
  const get = async (params: any): Promise<ExerciseSchema> => {
    return await db.exercises.get(params);
  };

  const findByIdsAndLibraryBookIds = async (
    idsAndLibraryBookIds: string[][]
  ): Promise<ExerciseSchema[]> => {
    const exercises = await db.exercises
      .where(['id+libraryBookId'])
      .anyOf(idsAndLibraryBookIds)
      .toArray();
    return exercises;
  };

  const findByIdsAndLibraryBookId = async (
    ids: string[],
    libraryBookId: string
  ): Promise<ExerciseSchema[]> => {
    const req = ids.map((id) => [id, libraryBookId]);

    const exercises = findByIdsAndLibraryBookIds(req);
    return exercises;
  };

  const findIdsByLibraryBookId = async (
    libraryBookId: string
  ): Promise<string[]> => {
    const exercises = await db.exercises
      .where('libraryBookId')
      .anyOf(libraryBookId)
      .toArray();

    const ids = exercises.map((pr) => pr.id);

    return ids;
  };

  const findByIds = async (ids: string[]): Promise<ExerciseSchema[]> => {
    return await db.exercises.where('id').anyOf(ids).toArray();
  };

  const findAll = async (): Promise<ExerciseSchema[]> => {
    return await db.exercises.toArray();
  };

  return {
    get,
    findByIdsAndLibraryBookIds,
    findByIdsAndLibraryBookId,
    findIdsByLibraryBookId,
    findByIds,
    findAll,
  };
};
